/**
 * Endpoints fot Glokal App services
 */
const _BASE_URL_PROD_ = "https://apps.glokalstore.com/api/client";
const _BASE_URL_QA_ = "https://qa-apps.glokalstore.com/api/client";

const _BASE_URL_ = window.location.href.includes("qa.glokalstore")
  ? _BASE_URL_QA_
  : _BASE_URL_PROD_;

const servicesApp = {
  habeasData: _BASE_URL_ + "/habeas_data/",
  contactUs: _BASE_URL_ + "/contact-us/",
  trackOrder: _BASE_URL_ + "/track_order/",
};

const authorizationProd = {
  habeasData: "Api-Key mPCv1SNl.p6vUk3ryr6xdYGxfhRLlluNPqJZOa4yL",
  contactUs: "Api-Key BhfFdgCA.lxzOOnFtcRdoCbwriqRXpzmvrkxtHXma",
  trackOrder: "Api-Key BhfFdgCA.lxzOOnFtcRdoCbwriqRXpzmvrkxtHXma",
};

const authorizationQa = {
  habeasData: "Api-Key yRkIQHO1.0LdCldhzLnbNnUZ9Em6XHTPCZsjmDWZv",
  contactUs: "Api-Key yRkIQHO1.0LdCldhzLnbNnUZ9Em6XHTPCZsjmDWZv",
  trackOrder: "Api-Key yRkIQHO1.0LdCldhzLnbNnUZ9Em6XHTPCZsjmDWZv",
};

const serviceAuthorization = window.location.href.includes("qa.glokalstore")
  ? authorizationQa
  : authorizationProd;
